import { ReactNode } from 'react';
import styles from './AboutUsSiteInnerContainer.module.css';

interface Props {
  withPadding?: boolean;
  background?: 'white';
  borderRadius?: boolean;
  overflowHidden?: boolean;
  positionRelative?: boolean;
  children: ReactNode;
}

const AboutUsSiteInnerContainer = (props: Props) => (
  <div
    className={`
      ${styles.innerContainer} 
      ${props.withPadding ? styles.withPadding : ''}
      ${styles['innerBackground__' + props.background]}
      ${props.borderRadius ? styles.borderRadius : ''}
      ${props.overflowHidden ? styles.overflowHidden : ''}
      ${props.positionRelative ? styles.positionRelative : ''}
    `}
  >
    {props.children}
  </div>
);

export default AboutUsSiteInnerContainer;
